import React from 'react';
import { useTheme } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import DSBox from '../../../design-system/DSBox';
import DSTypography from '../../../design-system/Typography/DSTypography';
import DSPrimaryButton from '../../../design-system/DSPrimaryButton';
import DSCollapsibleSection from '../../../design-system/DSCollapsibleSection';
import { HELP_DOWNLOADS } from '../../../consts/helpDownloads';

const PREVIEW_SIZE = 72;

const DownloadsSection = () => {
  const { palette, spacing } = useTheme();

  return (
    <DSCollapsibleSection title="Downloads">
      {HELP_DOWNLOADS.map((download, index) => (
        <DSBox
          key={download.id}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: spacing(2.25),
            padding: spacing(2.25, 3),
            borderTop: index > 0 ? `1px solid ${palette.white[5]}` : 'none',
          }}
        >
          <img
            src={download.previewImageUrl}
            alt={download.title}
            style={{
              width: PREVIEW_SIZE,
              height: PREVIEW_SIZE,
              flexShrink: 0,
              borderRadius: spacing(1),
              border: `1px solid ${palette.white[5]}`,
              backgroundColor: palette.common.white,
              objectFit: 'cover',
            }}
          />
          <DSBox sx={{ flex: 1, minWidth: 0 }}>
            <DSTypography variant="value" sx={{ color: palette.text.primary }}>
              {download.title}
            </DSTypography>
            <DSTypography
              variant="body2"
              sx={{
                color: palette.text.secondary,
                marginTop: spacing(0.5),
              }}
            >
              {download.subtitle}
            </DSTypography>
          </DSBox>
          <DSPrimaryButton
            href={download.downloadUrl}
            startIcon={<FileDownloadOutlinedIcon />}
            sx={{ flexShrink: 0, textDecoration: 'underline' }}
          >
            Download
          </DSPrimaryButton>
        </DSBox>
      ))}
    </DSCollapsibleSection>
  );
};

export default DownloadsSection;
